import { HardBreak } from '@tiptap/extension-hard-break';

export const CustomHardBreak = HardBreak.extend({
   name: 'customHardBreak',

   renderHTML() {
      return ['span', '⏎', ['br']];
   },
});
